import React from 'react';

import { useAPIData } from 'dal/useAPIData';
import useAudience from 'hooks/useAudience';
import { useContextId } from 'hooks/useSessionVariables';

const LoginContext = React.createContext({});

export const useLoginContext = () => React.useContext(LoginContext);

export const LoginContextProvider = ({ children }) => {
  const contextId = useContextId();
  const [audience] = useAudience();

  const [location, fetchInProgress, dataFetched, failedFetch] = useAPIData(
    'context.LOAD_CONTEXT',
    !contextId ? undefined : { contextId, audience: audience?.uuid },
    { reFetchWhen: [contextId], disableEmptyArgs: true }
  );

  return (
    <LoginContext.Provider value={{ location, fetchInProgress, dataFetched, failedFetch }}>
      {children}
    </LoginContext.Provider>
  );
};
